const getFeaturedCategories = (id = '') => `{
    getFeaturedCategories(uid: "${id}") {
        items {
            uid
            name
            image
            url_key
            category_favicon_image
        }
    }
}`;

export default {
    getFeaturedCategories,
};
